import { storeToRefs } from 'pinia'
import type { RouteLocationNormalized } from 'vue-router'

import { useCreateAccountStore, useUserStore } from '~/portal/stores'

export const personalDetailsMiddleWare = async (
	_: RouteLocationNormalized,
	__: RouteLocationNormalized
) => {
	const userStore = useUserStore()
	const accountStore = useCreateAccountStore()
	// eslint-disable-next-line @typescript-eslint/typedef
	const { account } = storeToRefs(accountStore)
	const { user } = storeToRefs(userStore)

	const isEmptyAccount = Object.values(account.value).some((value) => !!value)

	if (!isEmptyAccount && !user.value.is_invited) {
		return { name: 'account-create' }
	}
}
